import Utility from "../../../shared/utility";
import { store } from "../../../state-management/state-mgmt";
import * as JSPM from "jsprintmanager";
import EncryptUtility from "../../utility/js/encrypt-utility";
import commonAPIService from "../../common/js/common-api-service";
export default {
  name: "PrinterDetails",
  props: {
    printerDetailsDialog: Boolean,
    showPrimary: Boolean,
  },
  data() {
    return {
      printerType: "",
      labelPrinter: false,
      printerName: "",
      primaryCheck: EncryptUtility.localStorageDecrypt("primaryCheck"),
      secondaryCheck: EncryptUtility.localStorageDecrypt("secondaryCheck"),
      userId: EncryptUtility.localStorageDecrypt("userID"),
      secondaryName: EncryptUtility.localStorageDecrypt("secondaryName"),
      secondaryLabelSize: EncryptUtility.localStorageDecrypt("secondaryLabelSize"),
      secondaryPrinterType: EncryptUtility.localStorageDecrypt("secondaryPrinterType"),
      primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
      primaryLabelSize: EncryptUtility.localStorageDecrypt("primaryLabelSize"),
      primaryPrinterType: EncryptUtility.localStorageDecrypt("primaryPrinterType"),
      printerId: EncryptUtility.localStorageDecrypt("printerID"),
      printerIP: EncryptUtility.localStorageDecrypt("printerIP"),
      defaultCheck: EncryptUtility.localStorageDecrypt("defaultCheck"),
      defaultName: EncryptUtility.localStorageDecrypt("defaultName"),
      favouriteList: [],
      showAdd: false,
      printers: [],
      actionList: [],
      disableSave: true,
      showButtonsList: false,
      uniqSystemName: "",
      cookieTime: 60 * 60 * 24 * 365,
      labelsOn: true,
      primaryLabelSizeData: [
        {
          prilabelname: "2X4",
          prilabelvalue: "2X4",
        },
        {
          prilabelname: "4X6",
          prilabelvalue: "4X6",
        },
        {
          prilabelname: "4X6.75 LEADING DOC TAB",
          prilabelvalue: "4X6.75 LEADING DOC TAB",
        },
        {
          prilabelname: "4X6.75 TRAILING DOC TAB",
          prilabelvalue: "4X6.75 TRAILING DOC TAB",
        },
        {
          prilabelname: "4X8",
          prilabelvalue: "4X8",
        },
        {
          prilabelname: "4X9 LEADING DOC TAB",
          prilabelvalue: "4X9 LEADING DOC TAB",
        },
        {
          prilabelname: "4X9 TRAILING DOC TAB",
          prilabelvalue: "4X9 TRAILING DOC TAB",
        },
      ],
      primaryPrinterTypeData: [
        {
          priprintername: "ZEBRA",
          priprinterval: "ZEBRA",
        },
        {
          priprintername: "DATAMAX",
          priprinterval: "DATAMAX",
        },
      ],
      secondaryLabelSizeData: [
        {
          seclabelname: "1X3",
          seclabelvalue: "1X3",
        },
        {
          seclabelname: "2X4",
          seclabelvalue: "2X4",
        },
        {
          seclabelname: "4X6",
          seclabelvalue: "4X6",
        },
      ],
      secondaryPrinterTypeData: [
        {
          secprintername: "ZEBRA",
          secprinterval: "ZEBRA",
        },
        {
          secprintername: "DATAMAX",
          secprinterval: "DATAMAX",
        },
      ],
    };
  },
  mounted() {},
  created() {
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.labelsOn = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
    }
    if (this.labelsOn) {
      this.onInit();
    }
    this.showDetails();
    this.createUniqSystemName();
  },
  methods: {
    //This is used for resetting the form
    resetFunction() {
      this.primaryCheck = false;
      this.primaryName = "";
      this.primaryLabelSize = "";
      this.primaryPrinterType = "";
      this.secondaryCheck = false;
      this.secondaryName = "";
      this.secondaryLabelSize = "";
      this.secondaryPrinterType = "";
      this.defaultCheck = "";
      this.defaultName = "";
      this.disableSave = true;
      this.printerId = 0;
      if (this.printerDetailsDialog) {
        this.$refs.primaryForm.resetValidation();
        this.$refs.secondaryForm.resetValidation();
        this.$refs.defaultForm.resetValidation();
      }
    },
    //Close button click event in Popup
    closeDialog() {
      this.savedState();
      this.$emit("printerDetails", this.labelPrinter);
      this.printerDetailsDialog = false;
    },
    //Saved State
    savedState() {
      this.primaryCheck = Boolean(EncryptUtility.localStorageDecrypt("primaryCheck"));
      this.primaryName = EncryptUtility.localStorageDecrypt("primaryName");
      this.primaryLabelSize = EncryptUtility.localStorageDecrypt("primaryLabelSize");
      this.primaryPrinterType = EncryptUtility.localStorageDecrypt("primaryPrinterType");
      this.secondaryCheck = Boolean(EncryptUtility.localStorageDecrypt("secondaryCheck"));
      this.secondaryName = EncryptUtility.localStorageDecrypt("secondaryName");
      this.secondaryLabelSize = EncryptUtility.localStorageDecrypt("secondaryLabelSize");
      this.secondaryPrinterType = EncryptUtility.localStorageDecrypt("secondaryPrinterType");
      this.defaultCheck = EncryptUtility.localStorageDecrypt("defaultCheck");
      this.defaultName = EncryptUtility.localStorageDecrypt("defaultName");
    },
    //If Primary checkbox is checked
    isPrimary() {
      if (!this.primaryCheck) {
        this.primaryCheck = "";
        this.primaryName = "";
        this.primaryLabelSize = "";
        this.primaryPrinterType = "";
        this.disableSave = false;
        this.removePrimaryData();
        this.$refs.primaryForm.resetValidation();
      } else if (this.primaryCheck) {
        if (this.primaryName !== null || this.primaryName !== undefined) {
          if (this.primaryLabelSize !== null || this.primaryLabelSize !== undefined) {
            this.disableSave = false;
          }
        }
      }
    },
    //If Secondary checkbox is checked
    isSecondary() {
      if (!this.secondaryCheck) {
        this.secondaryCheck = "";
        this.secondaryName = "";
        this.secondaryLabelSize = "";
        this.secondaryPrinterType = "";
        this.disableSave = false;
        this.removeSecondaryData();
        this.$refs.secondaryForm.resetValidation();
      } else if (this.secondaryCheck) {
        if (this.secondaryName !== null || this.secondaryName !== undefined) {
          if (this.secondaryLabelSize !== null || this.secondaryLabelSize !== undefined) {
            this.disableSave = false;
          }
        }
      }
    },
    //If Default checkbox is checked
    isDefault() {
      if (!this.defaultCheck) {
        this.defaultCheck = "";
        this.defaultName = "";
        this.disableSave = false;
        this.removeDefaultData();
        this.$refs.defaultForm.resetValidation();
      } else if (this.defaultCheck) {
        if (this.defaultName !== null || this.defaultName !== undefined) {
          this.disableSave = false;
        }
      }
    },
    //Showing Printer Details
    showDetails() {
      if (this.showPrimary && this.primaryCheck) {
        if (this.primaryLabelSize !== undefined && this.primaryName !== undefined) {
          if (this.primaryLabelSize !== null && this.primaryName !== null) {
            this.printerType = this.primaryPrinterType;
            this.printerName = this.primaryName;
            this.labelPrinter = false;
            this.$emit("printerDetails", this.labelPrinter);
          } else {
            this.labelPrinter = true;
            this.$emit("printerDetails", this.labelPrinter);
          }
        } else {
          this.labelPrinter = true;
          this.$emit("printerDetails", this.labelPrinter);
        }
      } else if (this.secondaryCheck && !this.showPrimary) {
        if (this.secondaryLabelSize !== undefined && this.secondaryName !== undefined) {
          if (this.secondaryLabelSize !== null && this.secondaryName !== null) {
            this.printerType = this.secondaryPrinterType;
            this.printerName = this.secondaryName;
            this.labelPrinter = false;
            this.$emit("printerDetails", this.labelPrinter);
          } else {
            this.labelPrinter = true;
            this.$emit("printerDetails", this.labelPrinter);
          }
        } else {
          this.labelPrinter = true;
          this.$emit("printerDetails", this.labelPrinter);
        }
      } else {
        this.labelPrinter = true;
        this.$emit("printerDetails", this.labelPrinter);
      }
    },
    //Create a unique system name
    createUniqSystemName() {
      if (
        this.$cookies.get("uniqueSystemName") !== "" &&
        this.$cookies.get("uniqueSystemName") !== undefined &&
        this.$cookies.get("uniqueSystemName") !== null
      ) {
        this.uniqSystemName = this.$cookies.get("uniqueSystemName");
      } else {
        this.uniqSystemName = crypto.randomUUID();
      }
      this.$cookies.set("uniqueSystemName", this.uniqSystemName, this.cookieTime);
    },
    //On Save button click event from the breadcrumbs
    async saveData() {
      this.createUniqSystemName();
      if (this.primaryCheck || this.secondaryCheck || this.defaultCheck) {
        if (this.primaryCheck && this.$refs.primaryForm.validate() && !this.secondaryCheck && !this.defaultCheck) {
          this.removePrimaryData();
          EncryptUtility.localStorageEncrypt("primaryCheck", true.toString());
          EncryptUtility.localStorageEncrypt("primaryName", this.primaryName.toString());
          EncryptUtility.localStorageEncrypt("primaryLabelSize", this.primaryLabelSize.toString());
          EncryptUtility.localStorageEncrypt("primaryPrinterType", this.primaryPrinterType.toString());
          let printerObj = {
            json: JSON.stringify({
              user_id: parseInt(this.userId),
              pass: 2,
              printer_id:
                EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
              p_name: this.primaryName,
              p_size: this.primaryLabelSize,
              p_type: this.primaryPrinterType,
              s_name: "",
              s_size: "",
              s_type: "",
              ip: EncryptUtility.localStorageDecrypt("printerIP"),
              default_printer: "",
              machine_name: this.uniqSystemName,
            }),
          };
          let showMessage = false;
          let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
          if (printerData.message !== "NA") {
            EncryptUtility.localStorageRemoveItem("printerID");
            EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
            this.disableSave = true;
            let Alert = {
              type: "success",
              isShow: true,
              message: "Receiving/Inventory Printer is successfully configured.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        }
        if (this.secondaryCheck && this.$refs.secondaryForm.validate() && !this.primaryCheck && !this.defaultCheck) {
          this.removeSecondaryData();
          EncryptUtility.localStorageEncrypt("secondaryCheck", true.toString());
          EncryptUtility.localStorageEncrypt("secondaryName", this.secondaryName.toString());
          EncryptUtility.localStorageEncrypt("secondaryLabelSize", this.secondaryLabelSize.toString());
          EncryptUtility.localStorageEncrypt("secondaryPrinterType", this.secondaryPrinterType.toString());
          let printerObj = {
            json: JSON.stringify({
              user_id: parseInt(this.userId),
              pass: 2,
              printer_id:
                EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
              p_name: "",
              p_size: "",
              p_type: "",
              s_name: this.secondaryName,
              s_size: this.secondaryLabelSize,
              s_type: this.secondaryPrinterType,
              ip: EncryptUtility.localStorageDecrypt("printerIP"),
              default_printer: "",
              machine_name: this.uniqSystemName,
            }),
          };
          let showMessage = false;
          let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
          if (printerData.message !== "NA") {
            EncryptUtility.localStorageRemoveItem("printerID");
            EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
            this.disableSave = true;
            let Alert = {
              type: "success",
              isShow: true,
              message: "Shipping Printer is successfully configured.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        }
        if (this.defaultCheck && this.$refs.defaultForm.validate() && !this.primaryCheck && !this.secondaryCheck) {
          this.removeDefaultData();
          EncryptUtility.localStorageEncrypt("defaultCheck", true.toString());
          EncryptUtility.localStorageEncrypt("defaultName", this.defaultName.toString());
          let printerObj = {
            json: JSON.stringify({
              user_id: parseInt(this.userId),
              pass: 2,
              printer_id:
                EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
              p_name: "",
              p_size: "",
              p_type: "",
              s_name: "",
              s_size: "",
              s_type: "",
              ip: EncryptUtility.localStorageDecrypt("printerIP"),
              default_printer: this.defaultName,
              machine_name: this.uniqSystemName,
            }),
          };
          let showMessage = false;
          let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
          if (printerData.message !== "NA") {
            EncryptUtility.localStorageRemoveItem("printerID");
            EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
            this.disableSave = true;
            let Alert = {
              type: "success",
              isShow: true,
              message: "Default Printer is successfully configured.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        }
        if (this.primaryCheck && this.secondaryCheck && !this.defaultCheck) {
          if (this.$refs.primaryForm.validate() && this.$refs.secondaryForm.validate()) {
            this.removePrimaryData();
            EncryptUtility.localStorageEncrypt("primaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("primaryName", this.primaryName.toString());
            EncryptUtility.localStorageEncrypt("primaryLabelSize", this.primaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("primaryPrinterType", this.primaryPrinterType.toString());
            this.removeSecondaryData();
            EncryptUtility.localStorageEncrypt("secondaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("secondaryName", this.secondaryName.toString());
            EncryptUtility.localStorageEncrypt("secondaryLabelSize", this.secondaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("secondaryPrinterType", this.secondaryPrinterType.toString());
            let printerObj = {
              json: JSON.stringify({
                user_id: parseInt(this.userId),
                pass: 2,
                printer_id:
                  EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
                p_name: this.primaryName,
                p_size: this.primaryLabelSize,
                p_type: this.primaryPrinterType,
                s_name: this.secondaryName,
                s_size: this.secondaryLabelSize,
                s_type: this.secondaryPrinterType,
                ip: EncryptUtility.localStorageDecrypt("printerIP"),
                default_printer: "",
                machine_name: this.uniqSystemName,
              }),
            };
            let showMessage = false;
            let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
            if (printerData.message !== "NA") {
              EncryptUtility.localStorageRemoveItem("printerID");
              EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
              this.disableSave = true;
              let Alert = {
                type: "success",
                isShow: true,
                message: "Printers are successfully configured.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          }
        }
        if (this.primaryCheck && !this.secondaryCheck && this.defaultCheck) {
          if (this.$refs.primaryForm.validate() && this.$refs.defaultForm.validate()) {
            this.removePrimaryData();
            EncryptUtility.localStorageEncrypt("primaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("primaryName", this.primaryName.toString());
            EncryptUtility.localStorageEncrypt("primaryLabelSize", this.primaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("primaryPrinterType", this.primaryPrinterType.toString());
            this.removeDefaultData();
            EncryptUtility.localStorageEncrypt("defaultCheck", true.toString());
            EncryptUtility.localStorageEncrypt("defaultName", this.defaultName.toString());
            let printerObj = {
              json: JSON.stringify({
                user_id: parseInt(this.userId),
                pass: 2,
                printer_id:
                  EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
                p_name: this.primaryName,
                p_size: this.primaryLabelSize,
                p_type: this.primaryPrinterType,
                s_name: "",
                s_size: "",
                s_type: "",
                ip: EncryptUtility.localStorageDecrypt("printerIP"),
                default_printer: this.defaultName,
                machine_name: this.uniqSystemName,
              }),
            };
            let showMessage = false;
            let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
            if (printerData.message !== "NA") {
              EncryptUtility.localStorageRemoveItem("printerID");
              EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
              this.disableSave = true;
              let Alert = {
                type: "success",
                isShow: true,
                message: "Printers are successfully configured.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          }
        }
        if (!this.primaryCheck && this.secondaryCheck && this.defaultCheck) {
          if (this.$refs.secondaryForm.validate() && this.$refs.defaultForm.validate()) {
            this.removeSecondaryData();
            EncryptUtility.localStorageEncrypt("secondaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("secondaryName", this.secondaryName.toString());
            EncryptUtility.localStorageEncrypt("secondaryLabelSize", this.secondaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("secondaryPrinterType", this.secondaryPrinterType.toString());
            this.removeDefaultData();
            EncryptUtility.localStorageEncrypt("defaultCheck", true.toString());
            EncryptUtility.localStorageEncrypt("defaultName", this.defaultName.toString());
            let printerObj = {
              json: JSON.stringify({
                user_id: parseInt(this.userId),
                pass: 2,
                printer_id:
                  EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
                p_name: "",
                p_size: "",
                p_type: "",
                s_name: this.secondaryName,
                s_size: this.secondaryLabelSize,
                s_type: this.secondaryPrinterType,
                ip: EncryptUtility.localStorageDecrypt("printerIP"),
                default_printer: this.defaultName,
                machine_name: this.uniqSystemName,
              }),
            };
            let showMessage = false;
            let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
            if (printerData.message !== "NA") {
              EncryptUtility.localStorageRemoveItem("printerID");
              EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
              this.disableSave = true;
              let Alert = {
                type: "success",
                isShow: true,
                message: "Printers are successfully configured.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          }
        }
        if (this.primaryCheck && this.secondaryCheck && this.defaultCheck) {
          if (this.$refs.primaryForm.validate() && this.$refs.secondaryForm.validate() && this.$refs.defaultForm.validate()) {
            this.removePrimaryData();
            EncryptUtility.localStorageEncrypt("primaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("primaryName", this.primaryName.toString());
            EncryptUtility.localStorageEncrypt("primaryLabelSize", this.primaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("primaryPrinterType", this.primaryPrinterType.toString());
            this.removeSecondaryData();
            EncryptUtility.localStorageEncrypt("secondaryCheck", true.toString());
            EncryptUtility.localStorageEncrypt("secondaryName", this.secondaryName.toString());
            EncryptUtility.localStorageEncrypt("secondaryLabelSize", this.secondaryLabelSize.toString());
            EncryptUtility.localStorageEncrypt("secondaryPrinterType", this.secondaryPrinterType.toString());
            this.removeDefaultData();
            EncryptUtility.localStorageEncrypt("defaultCheck", true.toString());
            EncryptUtility.localStorageEncrypt("defaultName", this.defaultName.toString());
            let printerObj = {
              json: JSON.stringify({
                user_id: parseInt(this.userId),
                pass: 2,
                printer_id:
                  EncryptUtility.localStorageDecrypt("printerID") !== undefined ? parseInt(EncryptUtility.localStorageDecrypt("printerID")) : 0,
                p_name: this.primaryName,
                p_size: this.primaryLabelSize,
                p_type: this.primaryPrinterType,
                s_name: this.secondaryName,
                s_size: this.secondaryLabelSize,
                s_type: this.secondaryPrinterType,
                ip: EncryptUtility.localStorageDecrypt("printerIP"),
                default_printer: this.defaultName,
                machine_name: this.uniqSystemName,
              }),
            };
            let showMessage = false;
            let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
            if (printerData.message !== "NA") {
              EncryptUtility.localStorageRemoveItem("printerID");
              EncryptUtility.localStorageEncrypt("printerID", printerData?.printer_id?.toString());
              this.disableSave = true;
              let Alert = {
                type: "success",
                isShow: true,
                message: "Printers are successfully configured.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          }
        }
        if (!this.primaryCheck) {
          this.removePrimaryData();
        }
        if (!this.secondaryCheck) {
          this.removeSecondaryData();
        }
        if (!this.defaultCheck) {
          this.removeDefaultData();
        }
      } else if (!this.primaryCheck && !this.secondaryCheck && !this.defaultCheck) {
        let Alert = {
          type: "success",
          isShow: true,
          message: "Printer configuration is successfully cleared.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.disableSave = true;
      }
      this.showDetails();
    },
    //Remove primary printer details
    removePrimaryData() {
      EncryptUtility.localStorageRemoveItem("primaryCheck");
      EncryptUtility.localStorageRemoveItem("primaryName");
      EncryptUtility.localStorageRemoveItem("primaryLabelSize");
      EncryptUtility.localStorageRemoveItem("primaryPrinterType");
    },
    //Remove secondary printer details
    removeSecondaryData() {
      EncryptUtility.localStorageRemoveItem("secondaryCheck");
      EncryptUtility.localStorageRemoveItem("secondaryName");
      EncryptUtility.localStorageRemoveItem("secondaryLabelSize");
      EncryptUtility.localStorageRemoveItem("secondaryPrinterType");
    },
    //Remove default printer details
    removeDefaultData() {
      EncryptUtility.localStorageRemoveItem("defaultCheck");
      EncryptUtility.localStorageRemoveItem("defaultName");
    },
    //Removing the cookie data
    async removeData() {
      let printerObj = {
        json: JSON.stringify({
          user_id: parseInt(this.userId),
          pass: 3,
          printer_id: parseInt(EncryptUtility.localStorageDecrypt("printerID")),
          p_name: this.primaryName,
          p_size: this.primaryLabelSize,
          p_type: this.primaryPrinterType,
          s_name: this.secondaryName,
          s_size: this.secondaryLabelSize,
          s_type: this.secondaryPrinterType,
          ip: EncryptUtility.localStorageDecrypt("printerIP"),
          default_printer: this.defaultName,
        }),
      };
      let showMessage = true;
      let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
      if (printerData.message !== "NA") {
        this.removePrimaryData();
        this.removeSecondaryData();
        this.removeDefaultData();
        let Alert = {
          type: "success",
          isShow: true,
          message: "Printer configuration is successfully cleared.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.primaryCheck = "";
        this.primaryName = "";
        this.primaryLabelSize = "";
        this.primaryPrinterType = "";
        this.secondaryCheck = "";
        this.secondaryName = "";
        this.secondaryLabelSize = "";
        this.secondaryPrinterType = "";
        this.disableSave = true;
        this.$refs.primaryForm.resetValidation();
        this.$refs.secondaryForm.resetValidation();
        this.labelPrinter = true;
        this.$emit("printerDetails", this.labelPrinter);
      }
    },
    //Check same printers are being used or not
    checkPrinter(printers) {
      if (this.primaryCheck) {
        let priPrinter = printers.find((element) => element == this.primaryName);
        if (priPrinter == undefined && priPrinter == null) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Receiving/Inventory Printer is not configured.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      } else if (this.secondaryCheck) {
        let secPrinter = printers.find((element) => element == this.secondaryName);
        if (secPrinter == undefined && secPrinter == null) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Shipping Printer is not configured.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      } else if (this.defaultCheck) {
        let defPrinter = printers.find((element) => element == this.defaultName);
        if (defPrinter == undefined && defPrinter == null) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Default Printer is not configured.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
    },
    //Downloading the Printer software
    downloadUtility() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("co/cc_file_url?file_path=common/jspm7_0_2024.zip")
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var popup_window = window.open(response.data.body, "_blank");
            try {
              popup_window.focus();
            } catch (e) {
              let Alert = {
                type: "error",
                isShow: true,
                message: "Pop-up Blocker is enabled! Please add this site to your exception list.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
      LoaderDialog.visible = false;
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //Checking whether printer software is present in the system or not
    onInit() {
      var _this = this;
      JSPM.JSPrintManager.auto_reconnect = true;
      JSPM.JSPrintManager.start();
      if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
        _this.getPrinters().then((p) => {
          _this.printers = p;
          _this.checkPrinter(_this.printers);
          _this.$nextTick();
        });
      }
      var index = 0;
      JSPM.JSPrintManager.WS.onStatusChanged = function () {
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
          _this.getPrinters().then((p) => {
            _this.printers = p;
            _this.checkPrinter(p);
            _this.$nextTick();
          });
        } else {
          if (JSPM.JSPrintManager.websocket_status != JSPM.WSStatus.WaitingForUserResponse && index == 0) {
            alert(
              "Printer utility is not installed, please download the Printer utility from page menu and install. If it has already been downloaded, please open it. It is not running in the background."
            );
            index++;
          }
        }
      };
    },
    //Getting all the printers which are connected to the user device
    getPrinters() {
      return new Promise((ok, err) => {
        let printers = [];
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
          JSPM.JSPrintManager.getPrinters()
            .then(function (myPrinters) {
              printers = myPrinters;
              ok(printers);
            })
            .catch((e) => err(e));
        } else {
          console.warn("JSPM WS not open");
          alert(
            "Printer details --->Printer utility is not installed, please download the Printer utility from page menu and install. If it has already been downloaded, please open it. It is not running in the background."
          );
          ok(printers);
        }
      });
    },
  },
  printLabelData: function (value, primaryName) {
    if (primaryName !== null && primaryName !== undefined) {
      Utility.printZPL(primaryName, value);
      let Alert = {
        type: "success",
        isShow: true,
        message: "Success",
      };
      store.commit("ConfigModule/Alert", Alert);
    } else {
      var Alert = {
        type: "error",
        isShow: true,
        message: "Printer is not configured, please configure any printer from Printer Settings page.",
      };
      store.commit("ConfigModule/Alert", Alert);
    }
  },
  printLabelDataArray: function (array, primaryName) {
    if (primaryName !== null && primaryName !== undefined) {
      Utility.printZPLMultiple(primaryName, array);
      let Alert = {
        type: "success",
        isShow: true,
        message: "Success",
      };
      store.commit("ConfigModule/Alert", Alert);
    } else {
      var Alert = {
        type: "error",
        isShow: true,
        message: "Printer is not configured, please configure any printer from Printer Settings page.",
      };
      store.commit("ConfigModule/Alert", Alert);
    }
  },
};
